import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

const changeConnectionBlockTitle = () => {
  const bodyLoggedIn = document.querySelector('body.logged-in');

  if (bodyLoggedIn) {
    const connectionBlock = bodyLoggedIn.querySelector('.connexion-connection');
    const connectionBlockTitle = bodyLoggedIn.querySelector(
      '.connexion-connection h2'
    );

    if (connectionBlock && connectionBlockTitle) {
      connectionBlockTitle.textContent = _x(
        'Logged In',
        'connection block',
        'vtx'
      );
    }
  }
};

domReady(() => {
  changeConnectionBlockTitle();
});
